// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as bootstrap from "bootstrap"
import Rails from "@rails/ujs"

import "./controllers"

const initTooltips = () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
    bootstrap.Tooltip.getOrCreateInstance(element)
  })
}

document.addEventListener("turbo:load", initTooltips)
